import { render, staticRenderFns } from "./MyAsrResourcesModal.vue?vue&type=template&id=34d4ebbc&scoped=true"
import script from "./MyAsrResourcesModal.vue?vue&type=script&lang=js"
export * from "./MyAsrResourcesModal.vue?vue&type=script&lang=js"
import style0 from "./MyAsrResourcesModal.vue?vue&type=style&index=0&id=34d4ebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4ebbc",
  null
  
)

export default component.exports